import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./index.css";
import App from "./App";
import Redirect from "./Redirect";
import TrackingPage from "./TrackingPage";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/admin/:id" exact element={<TrackingPage />} />
      <Route path="/:id" exact element={<Redirect />} />
      <Route path="/" exact element={<App />} />
    </Routes>
  </BrowserRouter>
);
